
const {Liquid} = require('liquidjs')

const parse = (text, obj={}) => {
    return new DOMParser().parseFromString(new Liquid().parseAndRenderSync(text, obj), 'text/html').body
}

module.exports = {parse}
